import { useState } from "react";
import { Language, dictionary } from "../../../utils/dictionary";
import { MetaLoginResult, useMetaSDK } from "../../../hooks/useMetaSDK";
import {
  ChannelIntegrationWizard,
  messengerChannelConfig,
} from "../ChannelWizard";

interface ModalMessengerIntegrationProps {
  setModalOpen: (open: boolean) => void;
  handleOAuthComplete: (data: MetaLoginResult) => void;
  loading: boolean;
  language: Language;
}

const ModalMessengerIntegration = ({
  setModalOpen,
  handleOAuthComplete,
  loading,
  language,
}: ModalMessengerIntegrationProps) => {
  const { sdkReady, launchMessengerLogin } = useMetaSDK();
  const [sdkLoading, setSdkLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConnect = async () => {
    setError(null);
    setSdkLoading(true);
    try {
      const result = await launchMessengerLogin();
      handleOAuthComplete(result);
    } catch (err: unknown) {
      console.error("Messenger login failed:", err);
      setError(
        err instanceof Error
          ? err.message
          : dictionary["integration-error"]?.[language] || "Error connecting Messenger"
      );
    } finally {
      setSdkLoading(false);
    }
  };

  return (
    <ChannelIntegrationWizard
      config={messengerChannelConfig}
      language={language}
      loading={loading || sdkLoading}
      sdkReady={sdkReady}
      error={error}
      onClose={() => setModalOpen(false)}
      onConnect={handleConnect}
    />
  );
};

export default ModalMessengerIntegration;
